import React, { useEffect, useState } from 'react'

const useGalleryWidth = (ref: React.RefObject<any>, trigger?: any, elemSize = 110, items = 20): { itemsPerPage: number, elementSize: number } => {
  const [itemsPerPage, setItemsPerPage] = useState(items)
  const [elementSize, setElementSize] = useState(elemSize)

  useEffect(() => {
    const handleResize = () => {
      if (ref.current) {
        const containerWidth = ref.current.offsetWidth
        const elemProRow = Math.floor(containerWidth / elementSize)
        const remainingSpace = containerWidth - (elemProRow * elementSize)

        setItemsPerPage(elemProRow * 2) // two rows
        setElementSize(remainingSpace / elemProRow + elementSize - 5.2) // minus 5px margin + 0.2 interference leveled
      }
    }

    window.addEventListener('resize', handleResize)
    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [ref, trigger])

  return { itemsPerPage, elementSize }
}

export default useGalleryWidth
